// extracted by mini-css-extract-plugin
export default {"container":"style_container__dA4HX","titleFirst":"style_titleFirst__bGRWh","titleSecond":"style_titleSecond__bhfGL"};